import { create } from 'zustand';
import { api, PublicSettings } from '../api/client';

interface SettingsState {
  settings: PublicSettings | null;
  isLoading: boolean;
  error: string | null;
  loaded: boolean;

  // Actions
  fetchSettings: () => Promise<void>;
}

const defaultSettings: PublicSettings = {
  site_name: 'ProtectCord',
  site_description: 'Discord verification and security system',
  site_logo: null,
  maintenance_mode: false,
  maintenance_message: '',
  alert_enabled: false,
  alert_type: 'info',
  alert_message: '',
  turnstile_enabled: false,
  turnstile_site_key: '',
  ga_enabled: false,
  ga_measurement_id: '',
  ga_debug_mode: false,
  ga_anonymize_ip: true,
  ga_track_page_views: true,
  ga_track_outbound_links: true,
};

export const useSettingsStore = create<SettingsState>()((set, get) => ({
  settings: null,
  isLoading: false,
  error: null,
  loaded: false,

  fetchSettings: async () => {
    // Only fetch once
    if (get().loaded || get().isLoading) return;

    set({ isLoading: true, error: null });
    try {
      const response = await api.getPublicSettings();
      if (response.success) {
        set({
          settings: response.settings,
          isLoading: false,
          loaded: true,
        });
      } else {
        set({
          settings: defaultSettings,
          isLoading: false,
          loaded: true,
        });
      }
    } catch (error) {
      console.error('Failed to fetch public settings:', error);
      set({
        settings: defaultSettings,
        error: 'Failed to load settings',
        isLoading: false,
        loaded: true,
      });
    }
  },
}));
